module.exports = __webpack_public_path__ + "img/app_qr.0b1532b8.png";